<template>
  <div
    class="checkbox"
    :class="[vm.colorClass,
             { 'alt-font': altFont }]"
    :title="vm.title"
  >
    <input
      v-model="vm.isChecked"
      :name="vm.name"
      type="checkbox"
      @change="checkChanged"
    >
    <span class="checkbox" />
    <label>{{ vm.label }}</label>
  </div>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';
import storeKey from '@dui/mixins/store-key';

export default {
  mixins: [
    coloredComponent,
    storeKey,
  ],
  props: {
    altFont: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: null,
    },
  },
  data: function () {
    return {
      vm: {
        isChecked: this.checked,
        label: this.label,
        name: this.name,
        title: this.title,
      },
    };
  },
  computed: {
    storeOptions() {
      return this.loadFromStore();
    },
  },
  watch: {
    value: function(newVal) {
      this.$set(this.vm, 'isChecked', newVal);
    },
  },
  mounted() {
    if (this.storeLoadKey) {
      this.vm = this.storeOptions;
    }
  },
  methods: {
    checkChanged() {
      this.$emit('input', this.vm.isChecked);
      this.$emit('change');

      if (!this.storeUpdateKey) {
        return;
      }

      this.$store.dispatch(this.storeUpdateKey, this.vm.isChecked);
    },
  },
};
</script>
